import { render, staticRenderFns } from "./strongTips.vue?vue&type=template&id=a58df27a&scoped=true"
import script from "./strongTips.vue?vue&type=script&lang=js"
export * from "./strongTips.vue?vue&type=script&lang=js"
import style0 from "./strongTips.vue?vue&type=style&index=0&id=a58df27a&prod&scoped=true&lang=css"
import style1 from "./strongTips.vue?vue&type=style&index=1&id=a58df27a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58df27a",
  null
  
)

export default component.exports